import { Component, Children } from 'react';
import PropTypes from 'prop-types';
import withSideEffect from 'react-side-effect';

export const themePrefix = 'vgTheme-';

class BodyClass extends Component {
    render() {
        return Children.only(this.props.children);
    }
}

BodyClass.propTypes = {
    theme: PropTypes.string.isRequired, // eslint-disable-line react/no-unused-prop-types
    children: PropTypes.node.isRequired,
};

function reducePropsToState(propsList) {
    const theme = {};
    propsList.forEach((props) => {
        Object.assign(theme, props);
    });
    return theme;
}

function handleStateChangeOnClient(reducedProps) {
    let classNames = document.body.className.split(' ');
    classNames = classNames.filter((name) => name.indexOf(themePrefix) !== 0);
    classNames.push(reducedProps.theme);
    document.body.className = classNames.filter(Boolean).join(' ');
}

export default withSideEffect(reducePropsToState, handleStateChangeOnClient)(BodyClass);



/** WEBPACK FOOTER **
 ** ./src/local-components/BodyClass.js
 **/